export const environment = {
    production: true,
    envMode: 'prod',
    BASE_URL:"https://api-strategicpricing.edaa.siemens-energy.cloud/",
    debugShowSettings: false,
    azuread:{
        clientId: '5dc11521-e0f5-4d82-a487-0a5ce8c08fca',
        authority: 'https://login.microsoftonline.com/254ba93e-1f6f-48f3-90e6-e2766664b477',
        redirectUri: 'https://strategicpricing.edaa.siemens-energy.cloud/',
        postLogoutRedirectUri: '/'
    }
};
